/**
 * The GLOXAR mark, inline so it needs no network request. Same geometry as
 * apps/web/src/components/Logo.tsx and public/brand/gloxar-mark.svg; keep them in sync.
 */
export function Logo({ className = "h-6 w-6" }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <g
        fill="#f5b641"
        stroke="#0b0d12"
        strokeWidth="2.6"
        strokeLinejoin="round"
        strokeLinecap="round"
      >
        <path d="M32 4 56.25 18v28L32 60 7.75 46V18z" />
        <path d="M32 19.5 42.83 25.75v12.5L32 44.5l-10.83-6.25v-12.5z" />
        <path
          d="M32 4v15.5M56.25 18 42.83 25.75M56.25 46 42.83 38.25M32 60V44.5M7.75 46l13.42-7.75M7.75 18l13.42 7.75"
          fill="none"
        />
      </g>
    </svg>
  );
}
